import PropTypes from 'prop-types'
import React, { useState } from 'react'
import {
  Layout, Menu,
} from 'antd'
import {
  HomeOutlined, ShopOutlined, ReadOutlined,
  BankOutlined, AppstoreAddOutlined, ShareAltOutlined,
  PlaySquareOutlined, ProfileOutlined, BarsOutlined,
  PictureOutlined, UserOutlined,
} from '@ant-design/icons'
import Browser from 'utils/Browser'

const { Sider } = Layout
const { SubMenu } = Menu

const SideBar = ({
  handleKeys, site,
  collapse,currentUser,
}) => {
  const [isCollapse, setIsCollapse] = useState(false)
  const [isBroken, setIsBroken] = useState(false)
  const openKey = Array.isArray(site.activeSubPage) ? site.activeSubPage : [site.activeSubPage]

  return (
    <Sider
      theme="light"
      width={235}
      className="site-layout-background h-100"
      style={{ boxShadow: '-1px 1px 12px rgba(0, 34, 108, 0.15)' }}
      breakpoint="lg"
      collapsedWidth={isCollapse ? '0' : '84'}
      trigger={null}
      collapsible
      collapsed={isBroken ? !collapse : collapse}
      onBreakpoint={(broken) => {
        if (broken) {
          setIsCollapse(true)
          setIsBroken(true)
        } else {
          setIsCollapse(false)
          setIsBroken(false)
        }
      }}
      onCollapse={() => {

      }}
    >
      <div className="logo p-3 text-center">
        {isBroken
          ? <img src="/assets/kemdikbud_logo.png" className={`main-logo ${!collapse ? 'transition-logo' : ''}`} alt="logo" />
          : <img src="/assets/kemdikbud_logo.png" className={`main-logo ${collapse ? 'transition-logo' : ''}`} alt="logo" />
        }
      </div>
      <Menu
        theme="light"
        mode="inline"
        selectedKeys={[site.activePage]}
        openKeys={openKey}
        onClick={e => handleKeys(e)}
        onOpenChange={e => handleKeys(e, true)}
      >
        <Menu.Item key="dashboard">
          <HomeOutlined />
          <span><a onClick={()=>Browser.setWindowHref('/dashboard')}>Beranda</a></span>
        </Menu.Item>

        {/* <Menu.Item key="slideshow">
          <PictureOutlined />
          <span><a href="/slideshow">Slideshow</a></span>
        </Menu.Item> */}

        {/* <Menu.Item key="mitra">
          <ShopOutlined />
          <span><a href="/mitra">Mitra</a></span>
        </Menu.Item> */}

        <Menu.Item key="news">
          <ReadOutlined />
          <span><a onClick={()=>Browser.setWindowHref('/news')}>Berita</a></span>
        </Menu.Item>

        {/* <Menu.Item key="goverment">
          <BankOutlined />
          <span><a href="/goverment">Bantuan Pemerintah</a></span>
        </Menu.Item> */}
        { currentUser?.role === "Super Admin" && 
          <Menu.Item key="category">
            <AppstoreAddOutlined />
            <span><a onClick={()=>Browser.setWindowHref('/category')}>Kategori</a></span>
          </Menu.Item>
        }
        

        {/* <Menu.Item key="social-media">
          <ShareAltOutlined />
          <span><a href="/social-media">Social Media</a></span>
        </Menu.Item> */}

        {/* <Menu.Item key="video">
          <PlaySquareOutlined />
          <span><a href="/video">Video List</a></span>
        </Menu.Item> */}

        {/* <Menu.Item key="menu">
          <BarsOutlined />
          <span><a href="/menu">Menu List</a></span>
        </Menu.Item> */}

        {/* <SubMenu
          key="faq"
          title={(
            <React.Fragment>
              <ProfileOutlined />
              <span>F.A.Q</span>
            </React.Fragment>
          )}
        >
          <Menu.Item key="faq/category"><a href="/faq/category">Kategori</a></Menu.Item>
          <Menu.Item key="faq/list"><a href="/faq/list">List</a></Menu.Item>
        </SubMenu> */}

        <SubMenu
          key="user"
          title={(
            <React.Fragment>
              <UserOutlined />
              <span><a onClick={()=>Browser.setWindowHref('/user/list')}>Pengguna</a></span>
            </React.Fragment>
          )}
        >
          <Menu.Item key="user/list" onClick={()=>Browser.setWindowHref('/user/list')}>Daftar Pengguna</Menu.Item>
        </SubMenu>

        {/* <SubMenu
          key="toko"
          title={(
            <React.Fragment>
              <ContainerOutlined />
              <span>Toko</span>
            </React.Fragment>
          )}
        >
          <SubMenu key="submenu-toko" title="Toko Online">
            <Menu.Item key="toko/toko-online/tokopedia">Tokopedia</Menu.Item>
          </SubMenu>
          <Menu.Item key="toko/toko-online/faq">F.A.Q</Menu.Item>
        </SubMenu> */}

        {/* <Menu.Item key="users">
          <TeamOutlined />
          <span>User List</span>
        </Menu.Item> */}

        {/* <Menu.Divider className="my-3" /> */}

      </Menu>
    </Sider>
  )
}

SideBar.propTypes = {
  handleKeys: PropTypes.func,
  site: PropTypes.object,
  collapse: PropTypes.bool,
}

export default SideBar
